export default __webpack_public_path__ + "static/media/typography.a8d54feb.jpg";